import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FontForm from "./FontForm";
import { getFontById, editFont } from "../../../api/fontService";

export default function EditFont() {
  const location = useLocation();
  const id = location?.state?.fontId;

  const [font, setFont] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    loadFont();
  }, []);

  const loadFont = async () => {
    try {
      const res = await getFontById(id);
      setFont(res?.data || res);
    } catch (err) {
      console.log(err);
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    setLoading(true);

    try {
      const res = await editFont(id, formData);
      return res;
    } catch (err) {
      return err?.response?.data;
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) return <div>Loading...</div>;

  return (
    <div className="container p-4">
      <div className="card p-4">
        

        <FontForm
          initialValues={font}
          onSubmit={handleSubmit}
          loading={loading}
          buttonText="Update Font"
          isEdit={true}
        />
      </div>
    </div>
  );
}
